// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1ppwe","right":"styles_right__16eO0"};